import { useDeleteSearchMutation } from 'features/my-view/gql/_gen_/rec-review.gql';

export const useDeleteSearch = () => {
	const [deleteSearch, { loading, error }] = useDeleteSearchMutation({
		refetchQueries: ['GetUserSearches'],
	});
	return { deleteSearch, loading, error };
};
